import { createAction, props } from "@ngrx/store";

export const NewTokenAction = createAction(
  '[Token] New Token',
  props<{ token: string }>()
);

